module.exports = __webpack_public_path__ + "static/media/fishintv_intro.b72cb43e.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/media/fishintv_intro.mp4
// module id = 229
// module chunks = 0